<template>
  <div>
    <div class="editor">
    <editor-content :editor="editor" />
    </div>
  </div>
</template>

<script>
import { Editor, EditorContent } from 'tiptap'
import { Heading } from 'tiptap-extensions'
import Doc from './tiptap-doc-singleline.js'
import { Paragraph, Text } from 'tiptap'

export default {
  components: {
    EditorContent,
  },
  props: {
    value: {
      type: String,
      required: true
    },
    initialValue: {
      type: String,
      required: false
    }
  },
  computed: {
    text() {
      if (this.editor.getJSON().content[0].content === undefined) {
        return ""
      } else {
        return this.editor.getJSON().content[0].content[0].text
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) { 
        this.editor.setContent("<h1>" + newVal + "</h1>")
      }, 
    },
    text: {
      immediate: false, 
      handler(newVal, oldVal) { 
        this.$emit('input', newVal)
      }, 
    }
  },
  data() {
    return {
      initialTitleSet: false,
      editor: new Editor({
        useBuiltInExtensions: false,
        extensions: [
          new Doc(), // custom extension
          new Text(), // default extension
          new Paragraph(), // default extension
          new Heading({ levels: [1] }),
        ],
        content: `
          <h1>Untitled Links</h1>
        `,
      })
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>

<style lang="scss">
*:focus {
    outline: none;
}

</style>

<style scoped>
button {
    background-color:transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    width:30px;
    height:30px;
    border-radius: 3px;
    margin: 2px;
    /* border:1px solid gray; */
}

.is-active {
  background: lightgray
}
</style>